export default __webpack_public_path__ + "static/media/nurses.cdbcd5e0.jpg";